export default "/kefu.2f769e4f-24821a.png";